import { CircularProgress } from '@mui/material'
import { TranslatorDataContext } from 'context/TranslatorContext'
import useQuery from 'hooks/useQuery'
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

const CallFinishedTranslator = () => {
  const navigate = useNavigate()
  const { setAvailableRoom } = useContext(TranslatorDataContext)
  useQuery({
    defaultEndpoint: '/translators/finishCall',
    onResolve: () => {
      setAvailableRoom(null)
      navigate('/translators')
    },
  })

  return (
    <div className='flex justify-center items-center fixed top-0 left-0 w-[100vw] h-[100vh] z-[1000] bg-white'>
      <div className='flex items-center gap-2'>
        <CircularProgress color='secondary' />
        <p>Su llamada ha finalizado, espere unos segundos por favor...</p>
      </div>
    </div>
  )
}

export default CallFinishedTranslator
